<h2 mat-dialog-title class="generic-modal-header">
  <atom-label [text]="data.title || 'Título' " class="generic-modal-header__title"></atom-label>
  <atom-button  [isPrimaryButton]="false" [displayIcon]="true" [iconType]="'discard'" (click)="dialogRef.close()"></atom-button>
</h2>

<mat-dialog-content>
  <ng-container *ngIf="data.contentTemplate; else textContent">
    <ng-container *ngTemplateOutlet="data.contentTemplate"></ng-container>
  </ng-container>
  <ng-template #textContent>
    <div [innerHTML]="data.content"></div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
  <ng-container *ngIf="data.footerTemplate; else textFooter">
    <ng-container *ngTemplateOutlet="data.footerTemplate"></ng-container>
  </ng-container>
  <ng-template #textFooter>
    <div [innerHTML]="data.contentFooter"></div>
  </ng-template>
</mat-dialog-actions>
